import { Button } from "@mui/material";
import { ButtonRow } from "@synota-io/synota-shared-ui";
import { IDashboardContract } from "../../../../api/hooks/useContracts";
import { FindInPage } from "@mui/icons-material";
import { SearchStateLink } from "../../../../shared/layout/SearchStateLink";
import { generatePath } from "react-router-dom";
import { CONTRACTS_DETAIL_PATH } from "../../../../paths";

export const ContractDetailsCell = ({ contract }: { contract: IDashboardContract }) => {
  return (
    <ButtonRow>
      <Button
        component={SearchStateLink}
        title="Details"
        color="primary"
        to={generatePath(CONTRACTS_DETAIL_PATH, {
          id: contract.shared_uuid,
        })}
      >
        <FindInPage />
      </Button>
    </ButtonRow>
  );
};
